import PropTypes from 'prop-types';

import { contentfulSysType } from 'types/common/contentfulSys.types';

export const filterType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
});

export const lcTopFilterProps = {
  filters: PropTypes.arrayOf(filterType).isRequired,
};

export const lcTopFilterType = PropTypes.shape({
  sys: contentfulSysType.isRequired,
  ...lcTopFilterProps,
});

export const lcTopFilterComponentProp = {
  filter: filterType.isRequired,
};
